/**
 * Whether a workflow stage kind carries one linear successor and therefore
 * leaves its chain open for another stage. Pages and Change Owner nodes are
 * linear; Review / Branch nodes continue through their own lanes, and End is
 * terminal (§6.2.2 / §6.2.3 / §6.3 / #2225 / #3643).
 *
 * Accepts the raw string kind because the wire model calls it ``kind`` while
 * the canvas display model calls the same string union ``type``.
 */
export function isOpenLinearWorkflowTailKind(
  kind: string | undefined,
): kind is "page" | "change_owner" {
  return kind === "page" || kind === "change_owner";
}
